<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8">
        <v-snackbar color="red" location="top" v-if="message" v-model="message">
            {{ message }}
            <template v-slot:actions>
                <v-btn variant="text" @click="message = null">
                    X
                </v-btn>
            </template>
        </v-snackbar>
        <v-progress-circular v-if="loading" />
    </v-col>
  </v-row>
</template>

<script>
import {useRoute} from "vue-router";
import authservice from "@/services/authservice";

export default {
  name: 'CompleteSignupView',
  components: {
  },
  data: () => ({
      loading: true,
      message: null,
  }),
  setup: () => {
      const route = useRoute();
      const key = route.query.key;
      const email = route.query.mail;
      return { key, email }
  },
  mounted() {
      authservice.validate(this.key, this.email).then(() => {
          this.loading = false;
          this.$router.push("/login");
      }, (error) => {
          this.loading = false;
          this.message =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
      })
  }

}
</script>